import React from "react";
import "./BudgetTracker.css";
import SetBudget from "./SetBudget";
import AddExpense from "./AddExpense";
import HorizontalBars from "./HorizontalBars";
import { ReactComponent as CurrentSpendIcon } from "../../assets/current-spend.svg";
import { ReactComponent as AttractionIcon } from "../../assets/attraction-icon.svg";
import { ReactComponent as TransportIcon } from "../../assets/transport-icon.svg";
import { ReactComponent as ShoppingIcon } from "../../assets/shopping-icon.svg";
import { ReactComponent as FoodIcon } from "../../assets/food-icon.svg";
import { ReactComponent as OtherIcon } from "../../assets/other-icon.svg";
import { ReactComponent as TargetIcon } from "../../assets/target-icon.svg";
import useBudgetExpenses from "./useBudgetExpenses"; // <-- new hook

function BudgetTracker() {
  const { expenses, updateCategory, loading, error } = useBudgetExpenses();
  const calculateTotal = (items) =>
    items.reduce((sum, item) => sum + (parseFloat(item.budget) || 0), 0);

  //calculating totals by category
  const totals = {
    attractions: calculateTotal(expenses.attractions),
    transport: calculateTotal(expenses.transport),
    food: calculateTotal(expenses.food),
    shopping: calculateTotal(expenses.shopping),
    other: calculateTotal(expenses.other),
  };

  const totalExpense = Object.values(totals).reduce((a, b) => a + b, 0);

  if (loading) return <p>Loading budget data...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <div className="budget-container">
        <div className="set-budget">
          <div className="budget-label">
            <TargetIcon />
            <p>Trip Budget</p>
          </div>
          <SetBudget />
        </div>
        <div className="budget-spend">
          <div className="budget-label">
            <CurrentSpendIcon />
            <p>Current Spending</p>
          </div>
          <span className="total-spend-value">{totalExpense.toFixed(2)}</span>
        </div>
      </div>

      <div className="expense-container">
        <h2>Detailed Expenses</h2>

        <AttractionIcon />
        <AddExpense
          expenses={expenses.attractions}
          heading="Attractions & Trips"
          setExpenses={(e) => updateCategory("attractions", e)}
        />

        <TransportIcon />
        <AddExpense
          expenses={expenses.transport}
          heading="Transport"
          setExpenses={(e) => updateCategory("transport", e)}
        />

        <FoodIcon />
        <AddExpense
          expenses={expenses.food}
          heading="Food & Drink"
          setExpenses={(e) => updateCategory("food", e)}
        />

        <ShoppingIcon />
        <AddExpense
          expenses={expenses.shopping}
          heading="Shopping"
          setExpenses={(e) => updateCategory("shopping", e)}
        />

        <OtherIcon />
        <AddExpense
          expenses={expenses.other}
          heading="Other"
          setExpenses={(e) => updateCategory("other", e)}
        />
      </div>

      <div className="expense-table">
        <h2 className="barChart-heading">Total Spending by Expense Category</h2>
        <HorizontalBars
          attractions={totals.attractions}
          transport={totals.transport}
          food={totals.food}
          shopping={totals.shopping}
          other={totals.other}
        />
      </div>
    </>
  );
}

export default BudgetTracker;
